/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Office/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Location from './Location/index'
import OfficeIcon from './OfficeIcon/index'
import ProfileData from './ProfileData/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Office({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Details/Office/Search/Content/Content/Offices/Content/Office"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<button
  data-testid="Office.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mt-1-Z2hO0oT': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal}`}
>
<OfficeIcon
  viewPath={`${viewPath}/OfficeIcon`}
/>
<div
  data-testid="Office.Vertical"
  data-view-path={viewPath}
 style={{'--ml-2-Z2hO0oT': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<ProfileData
  viewPath={`${viewPath}/ProfileData`}
/>
<div
  data-testid="Office.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Location
  viewPath={`${viewPath}/Location`}
/>
</div>
</div>
</button>
{children}
</React.Fragment>)
}